import { useContext, useRef, useState } from "react";
import { getCurrentUser, signInAccount } from "../../Api/Services/Account";
import RegisterButton from "../../components/Header/RegisterButton/RegisterButton";
import SignInButton from "../../components/Header/SignInButton/SignInButton";
import styles from "./signin.module.css";
import { LoginDt } from "../../Models/AccountModel";
import { AccountContext } from "../../Store/Account.store";
import { Link, useNavigate } from "react-router-dom";

export default function SignIn() {
  const emailRef = useRef<HTMLInputElement>(null);
  const passwordRef = useRef<HTMLInputElement>(null);
  const [loginError, setLoginError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const {setAccountData} = useContext(AccountContext);
  const navigate = useNavigate();

  const signInUser = () => {
    if (emailRef.current?.value.trim() == "") {
      setEmailError(true);
      return;
    }
    if (passwordRef.current?.value.trim() == "") {
      setPasswordError(true);
      return;
    }
    const data: LoginDt = {email: emailRef.current?.value as string, password: passwordRef.current?.value as string};
    signInAccount(data).then((data) => {
      if (data.success) {
        getCurrentUser().then((data) => {
          if (data.userName != "" && data.userName != undefined) {
            const userObj = {isauthenticated: true, username: data.userName, roles: data.roles};
            setAccountData(userObj);
            localStorage.setItem("user", JSON.stringify(userObj));
            navigate('/advertise-your-alternative');    
          }else{
            localStorage.removeItem("user");
          }
        });
      }else{
        setLoginError(true);
      }
    });
  }

  const switchToRegister = () => {
    navigate('/register');
  }

  return (
    <div className={styles.container}>
      <h1>Sign In</h1>
      <p>
        Login is only required to advertise at the Marketplace. No login is
        needed to browse the ads of others.
      </p>
      
      <form >
        <div className={styles.email}>
          <label htmlFor="email" className={styles.label}>
            Email address
          </label>
          <input
            ref={emailRef}
            type="email"
            id="email"
            name="email"
            className={`${styles.input} ${loginError || emailError ? 'error' : ''}`}
            onBlur={() => {setLoginError(false); setEmailError(false)}}
            placeholder="Your email address"
          />
          {emailError && <p className="error_text">Email is required.</p>}
          {loginError && <p className="error_text">Invalid login attempt.</p>}
        </div>
        <div className={styles.password}>
          <label htmlFor="password" className={styles.label}>
            Password
          </label>
          <input
            ref={passwordRef}
            type="password"
            id="password"
            name="password"
            className={`${styles.input} ${loginError || passwordError ? 'error' : ''}`}
            onBlur={() => {setLoginError(false); setPasswordError(false)}}
            placeholder="*****"
          />
          {passwordError && <p className="error_text">Password is required.</p>}
        </div>
        <Link to="/forgot-password" className={styles.forgotPassword}>Forgot your password?</Link>

        <SignInButton isLoginPage={true} handleOnClick={signInUser}/>
        <RegisterButton isLoginPage={true} HandleOnClick={switchToRegister}/>
      </form>
    </div>
  );
}
